import React from 'react';
import { Tabs } from 'antd';
import './CTabs.scss';

const CTabs = (props) => {
  return <Tabs {...props} className={`c-tabs ${props.className || ''}`} />;
};

export default CTabs;
